import { atom, selector, selectorFamily } from 'recoil';
import type { BlockId } from './types';
import { blockSettings } from './configuration/blockSettings';
import { studioBlockCustomWidth } from './grid';
import type { VirtuosoHandle } from 'react-virtuoso';
import type { CustomizableBlockSetting } from 'venn-utils';
import { resetOnStudioReset } from '../effects/signalEffects';

export const studioLeftPanelOpen = atom<boolean>({
  key: 'studioLeftPanelOpen',
  default: true,
});

export const selectedBlocksState = atom<BlockId[]>({
  key: 'selectedBlocksState',
  default: [],
  effects: [resetOnStudioReset],
});

/**
 * @deprecated multiple blocks can now be selected at once
 *
 * TODO: delete when block_assignment_ff is deleted.
 */
export const selectedBlockIdState = selector<BlockId | undefined>({
  key: 'selectedBlockIdState',
  get: ({ get }) => get(selectedBlocksState)[0],
});

export const isSelectedBlockState = selectorFamily<boolean, BlockId>({
  key: 'isSelectedBlock',
  get:
    (blockId) =>
    ({ get }) => {
      const selectedBlocks = get(selectedBlocksState);
      return !!selectedBlocks?.some((selectedBlock) => selectedBlock === blockId);
    },
});

export const selectedBlockSettings = selector<CustomizableBlockSetting | undefined>({
  key: 'selectedBlockSettings',
  get: ({ get }) => {
    const selected = get(selectedBlockIdState);
    return selected ? get(blockSettings(selected)) : undefined;
  },
});

export const selectedBlockRelativeWidth = selector<number | undefined>({
  key: 'selectedBlockRelativeWidth',
  get: ({ get }) => {
    const selected = get(selectedBlockIdState);
    return selected ? get(studioBlockCustomWidth(selected)) : undefined;
  },
  set: ({ get, set }, value) => {
    const selected = get(selectedBlockIdState);
    selected && value && set(studioBlockCustomWidth(selected), value);
  },
});

export const studioImageUploading = atom<boolean>({
  key: 'studioImageUploading',
  default: false,
});
export const sectionPageImageUploading = atom<boolean>({
  key: 'sectionPageImageUploading',
  default: false,
});

export const virtualScrollRef = atom<{ current: VirtuosoHandle | null } | undefined>({
  key: 'virtualScrollRef',
  default: undefined,
});
